export function dummy() {}

export function getQueryString(formData) {
  const params = new URLSearchParams()
  const keys = Object.keys(formData)
  keys.forEach((key) => {
    params.append(key, formData[key])
  })
  return params.toString()
}
